// eslint-disable-next-line import/prefer-default-export
export var DEFAULT_DASHBOARD_ID = 'default';
//# sourceMappingURL=DashboardConstants.js.map